import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import apiClient from '../api/apiClient';

const ProfileEdit = () => {
  const { username } = useParams();
  const [data, setData] = useState(null);
  const [form, setForm] = useState(null);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await apiClient.get(`profile/${username}/`).json();
      setData(res);
      setForm(res);
    })();
  }, [username]);

  const handleChange = (path, value) => {
    const updated = { ...form };
    const keys = path.split('.');
    let obj = updated;
    while (keys.length > 1) obj = obj[keys.shift()];
    obj[keys[0]] = value;
    setForm(updated);
    setChanged(true);
  };

  const handleSave = async () => {
    console.log('Sending:', form);
    await apiClient.patch(`profile/${username}/`, form);
    setChanged(false);
  };

  if (!form) return <Typography color="white">Loading...</Typography>;

return (
    <Box sx={{ p: 4, bgcolor: '#000', minHeight: '100vh', color: '#fff' }}>
        <Typography variant="h4" sx={{ mb: 3, background: 'linear-gradient(90deg, #ff8a00, #e52e71)', WebkitBackgroundClip: 'text', color: 'transparent' }}>Edit Profile</Typography>

        <Grid container spacing={3}>
            <Grid item xs={12}><Typography variant="h6">Basic Info</Typography><Divider sx={{ my: 1, bgcolor: 'grey.800' }} /></Grid>
            {['full_name', 'phone_number', 'email_id'].map((field) => (
                <Grid item xs={12} md={6} key={field}>
                    <TextField
                        fullWidth
                        label={field.replace('_', ' ').toUpperCase()}
                        value={form[field] || ''}
                        onChange={(e) => handleChange(field, e.target.value)}
                        InputProps={{ sx: { color: '#fff' } }}
                    />
                </Grid>
            ))}

            <Grid item xs={12}><Typography variant="h6">Personal Details</Typography><Divider sx={{ my: 1, bgcolor: 'grey.800' }} /></Grid>
            {Object.entries(form.personal_details || {}).map(([k, v]) => (
                <Grid item xs={12} md={6} key={k}>
                    <TextField
                        fullWidth
                        label={k.replace('_', ' ').toUpperCase()}
                        value={v || ''}
                        onChange={(e) => handleChange(`personal_details.${k}`, e.target.value)}
                        InputProps={{ sx: { color: '#fff' } }}
                        multiline={k === 'bio'}
                        rows={k === 'bio' ? 5 : 1}
                    />
                </Grid>
            ))}

            <Grid item xs={12}><Typography variant="h6">Social Links</Typography><Divider sx={{ my: 1, bgcolor: 'grey.800' }} /></Grid>
            {Object.entries(form.social_links || {}).map(([k, v]) => (
                <Grid item xs={12} md={6} key={k}>
                    <TextField
                        fullWidth
                        label={k.toUpperCase()}
                        value={v || ''}
                        onChange={(e) => handleChange(`social_links.${k}`, e.target.value)}
                        InputProps={{ sx: { color: '#fff' } }}
                    />
                </Grid>
            ))}
        </Grid>

        <Button
            variant="contained"
            disabled={!changed}
            onClick={handleSave}
            sx={{ mt: 4, bgcolor: '#fff', color: '#000', fontWeight: 'bold', borderRadius: 2, '&:hover': { bgcolor: '#eee' } }}
        >
            Save Changes
        </Button>
    </Box>
);
};

export default ProfileEdit;
